import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=0034cf90&scoped=true&"
import script from "./FormModal.vue?vue&type=script&lang=ts&"
export * from "./FormModal.vue?vue&type=script&lang=ts&"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=0034cf90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0034cf90",
  null
  
)

export default component.exports